import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";

import { ApiOverride } from "./ApiOverrides";
import { TRootStore } from "./RootStore";
import { AppSettings } from "Store/AppSettingStore";

type SettingKey = keyof AppSettings;

export const ApiServiceStore = (root: TRootStore, baseUrlSetting: SettingKey = "ospServiceApiUrl", authHeaderName: string = "Authorization") => {
    const apiOverride = ApiOverride();
    let axiosInstance: AxiosInstance;
    return {
        initialize() {
            axiosInstance = axios.create({
                baseURL: root.AppSettingStore.settings[baseUrlSetting],
                paramsSerializer: {
                    indexes: null
                }
            });
            axiosInstance.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
                config.timeout = apiOverride.getApiTimeOut(config);

                if (apiOverride.isAnonymousApi(config.baseURL ?? "", config.url ?? "")) {
                    return config;
                }

                if (apiOverride.isCookieAuthApi(config.baseURL ?? "", config.url ?? "") || root.AuthStore.temporaryLogin) {
                    config.withCredentials = true;
                    return config;
                }

                const token = await root.AuthStore.getToken();
                if (token) {
                    config.headers[authHeaderName] = "Bearer " + token;
                }

                return config;
            });
        },
        get axiosInstance() {
            return axiosInstance;
        },
        setBaseUrl(url: string) {
            axiosInstance.defaults.baseURL = url;
        }
    };
};
